export function tiempoTranscurrido(fecha) {
  const fechaObj = new Date(fecha);
  const horas = fechaObj.getHours().toString().padStart(2, "0");
  const minutos = fechaObj.getMinutes().toString().padStart(2, "0");
  return `${horas}:${minutos}`;
}
